import { titleCase } from 'title-case';

export type Enum<K extends string, V> = Readonly<Record<K, V>>;

const factory = <K extends string, V, T extends Enum<K, V>>(values: T): T => {
    return Object.freeze(values);
};

export const Enum = Object.assign(
    factory,
    {
        default(e: any) {
            return e[Object.keys(e)[0]];
        },
        values<K extends string, V>(e: Enum<K, V>): V[] {
            return Object.values(e);
        },
        label<T>(e: T, value: T[keyof T]): string {
            const k = Object.keys(e).filter(k => e[k] === value);
            return titleCase((k ?? '').toString());
        },
    }
);
